"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeoCleanURLTranslations = void 0;
exports.SeoCleanURLTranslations = {
    realEstate: {
        hy: 'ansharzh-guik-',
        ru: 'nedvizhimost-',
        en: 'real-estate-',
    },
    propertyType: {
        apartment: {
            hy: 'bnakaran-',
            ru: 'kvartira-',
            en: 'apartments-',
        },
        house: {
            hy: 'sepakan-tun-',
            ru: 'chastniy-dom-',
            en: 'house-',
        },
        commercial: {
            hy: 'komercion-tarack-',
            ru: 'kommercheskaya-',
            en: 'commercial-',
        },
    },
    fromDeveloper: {
        hy: 'karucapatoghic-',
        ru: 'ot-zastroishika-',
        en: 'new-development-',
    },
    realEstateFromDeveloper: {
        hy: 'ansharzh-guik-karucapatoghic-',
        ru: 'nedvizhimost-ot-zastroishika-',
        en: 'new-development-',
    },
    propertyFromDeveloper: {
        apartment: {
            hy: 'bnakaran-karucapatoghic-',
            ru: 'kvartiri-ot-zastroishika-',
            en: 'apartment-new-development-',
        },
        house: {
            hy: 'sepakan-tun-karucapatoghic-',
            ru: 'chastniy-dom-ot-zastroishika-',
            en: 'house-new-development-',
        },
        commercial: {
            hy: 'komercion-tarack-karucapatoghic-',
            ru: 'kommercheskaya-nedvizhimost-ot-zastroishika-',
            en: 'commercial-new-development-',
        },
    },
    newBuilding: {
        hy: 'norakaruyc-ansharzh-guik-',
        ru: 'novostroika-',
        en: 'new-',
    },
    // newBuildingFromDeveloper: {
    //     hy: 'norakaruyc-ansharzh-guik-karucapatoghic-',
    //     ru: 'novostroika-ot-zastroishika-',
    //     en: ''
    // },
    apartmentNewBuildingFromDeveloper: {
        hy: 'norakaruyc-bnakaran-karucapatoghic-',
        ru: 'kvartiri-v-novostroikax-ot-zastroishika-',
        en: 'new-apartment-new-development-',
    },
    houseNewBuildingFromDeveloper: {
        hy: 'norakaruyc-sepakan-tun-karucapatoghic-',
        ru: 'chastnie-doma-novostroiki-ot-zastroishika-',
        en: 'new-house-new-development-',
    },
    commercialNewBuildingFromDeveloper: {
        hy: 'norakaruyc-komercion-tarack-karucapatoghic-',
        ru: 'kommercheskaya-nedvizhimost-v-novostroikax-ot-zastroishika-',
        en: 'new-commercial-new-development-',
    },
    roomWithApartment: {
        one: {
            hy: '1-senyakanoc-bnakaran-',
            ru: '1-komnatnaya-kvartira-',
            en: '1-room-apartment-',
        },
        two: {
            hy: '2-senyakanoc-bnakaran-',
            ru: '2-komnatnaya-kvartira-',
            en: '2-room-apartment-',
        },
        tree: {
            hy: '3-senyakanoc-bnakaran-',
            ru: '3-komnatnaya-kvartira-',
            en: '3-room-apartment-',
        },
        four: {
            hy: '4-senyakanoc-bnakaran-',
            ru: '4-komnatnaya-kvartira-',
            en: '4-room-apartment-',
        },
    },
    roomWithHouse: {
        one: {
            hy: '1-senyakanoc-sepakan-tun-',
            ru: '1-komnatniy-chastniy-dom-',
            en: '1-room-house-',
        },
        two: {
            hy: '2-senyakanoc-sepakan-tun-',
            ru: '2-komnatniy-chastniy-dom-',
            en: '2-room-house-',
        },
        tree: {
            hy: '3-senyakanoc-sepakan-tun-',
            ru: '3-komnatniy-chastniy-dom-',
            en: '3-room-house-',
        },
        four: {
            hy: '4-senyakanoc-sepakan-tun-',
            ru: '4-komnatniy-chastniy-dom-',
            en: '4-room-house-',
        },
    },
    roomNewBuildingApartment: {
        one: {
            hy: '1-senyakanoc-norakaruic-bnakaran-',
            ru: '1-komnatnaya-kvartira-v-novostroike-',
            en: '1-room-new-apartment-',
        },
        two: {
            hy: '2-senyakanoc-norakaruic-bnakaran-',
            ru: '2-komnatnaya-kvartira-v-novostroike-',
            en: '2-room-new-apartment-',
        },
        tree: {
            hy: '3-senyakanoc-norakaruic-bnakaran-',
            ru: '3-komnatnaya-kvartira-v-novostroike-',
            en: '3-room-new-apartment-',
        },
        four: {
            hy: '4-senyakanoc-norakaruic-bnakaran-',
            ru: '4-komnatnaya-kvartira-v-novostroike-',
            en: '4-room-new-apartment-',
        },
    },
    roomNewBuildingHouse: {
        one: {
            hy: '1-senyakanoc-norakaruic-sepakan-tun-',
            ru: '1-komnatniy-chastniy-dom-novostroika-',
            en: '1-room-new-house-',
        },
        two: {
            hy: '2-senyakanoc-norakaruic-sepakan-tun-',
            ru: '2-komnatniy-chastniy-dom-novostroika-',
            en: '2-room-new-house-',
        },
        tree: {
            hy: '3-senyakanoc-norakaruic-sepakan-tun-',
            ru: '3-komnatniy-chastniy-dom-novostroika-',
            en: '3-room-new-house-',
        },
        four: {
            hy: '4-senyakanoc-norakaruic-sepakan-tun-',
            ru: '4-komnatniy-chastniy-dom-novostroika-',
            en: '4-room-new-house-',
        },
    },
    propertyTypeWithDailyPrize: {
        hy: 'oravardzov-bnakaran-',
        ru: 'posutochno-kvartiri-',
        en: 'daily-rent-apartment-',
    },
    newBuildingPropertyDailyPrice: {
        hy: 'oravardzov-norakaruic-bnakaran-',
        ru: 'posutochno-kvartiri-v-novostroikax-',
        en: 'daily-rent-new-apartment-',
    },
    newBuildingApartmentWithRoom: {
        one: {
            hy: 'oravardzov-1-senyakanoc-norakaruic-bnakaran-',
            ru: 'posutochno-1-komnatnaya-kvartira-v-novostroike-',
            en: 'daily-rent-1-room-new-apartment-',
        },
        two: {
            hy: 'oravardzov-2-senyakanoc-norakaruic-bnakaran-',
            ru: 'posutochno-2-komnatnaya-kvartira-v-novostroike-',
            en: 'daily-rent-2-room-new-apartment-',
        },
        tree: {
            hy: 'oravardzov-3-senyakanoc-norakaruic-bnakaran-',
            ru: 'posutochno-3-komnatnaya-kvartira-v-novostroike-',
            en: 'daily-rent-3-room-new-apartment-',
        },
        four: {
            hy: 'oravardzov-4-senyakanoc-norakaruic-bnakaran-',
            ru: 'posutochno-4-komnatnaya-kvartira-v-novostroike-',
            en: 'daily-rent-4-room-new-apartment-',
        },
    },
    newBuildingHouseRoomDaily: {
        one: {
            hy: 'oravardzov-1-senyakanoc-norakaruic-arandznatun-',
            ru: 'posutochno-1-komnatniy-chastniy-dom-novostroika-',
            en: 'daily-rent-1-room-new-house-',
        },
        two: {
            hy: 'oravardzov-2-senyakanoc-norakaruic-arandznatun-',
            ru: 'posutochno-2-komnatniy-chastniy-dom-novostroika-',
            en: 'daily-rent-2-room-new-house-',
        },
        tree: {
            hy: 'oravardzov-3-senyakanoc-norakaruic-arandznatun-',
            ru: 'posutochno-3-komnatniy-chastniy-dom-novostroika-',
            en: 'daily-rent-3-room-new-house-',
        },
        four: {
            hy: 'oravardzov-4-senyakanoc-norakaruic-arandznatun-',
            ru: 'posutochno-4-komnatniy-chastniy-dom-novostroika-',
            en: 'daily-rent-4-room-new-house-',
        },
    },
    newBuildingHouseRoom: {
        one: {
            hy: '1-senyakanoc-norakaruic-arandznatun-',
            ru: '1-komnatniy-chastniy-dom-novostroika-',
            en: '1-room-new-house-',
        },
        two: {
            hy: '2-senyakanoc-norakaruic-arandznatun-',
            ru: '2-komnatniy-chastniy-dom-novostroika-',
            en: '2-room-new-house-',
        },
        tree: {
            hy: '3-senyakanoc-norakaruic-arandznatun-',
            ru: '3-komnatniy-chastniy-dom-novostroika-',
            en: '3-room-new-house-',
        },
        four: {
            hy: '4-senyakanoc-norakaruic-arandznatun-',
            ru: '4-komnatniy-chastniy-dom-novostroika-',
            en: '4-room-new-house-',
        },
    },
    newBuildingApartmentsWithRooms: {
        one: {
            hy: 'oravardzov-1-senyakanoc-bnakaran-',
            ru: 'posutochno-1-komnatnaya-kvartira-',
            en: 'daily-rent-1-room-apartment-',
        },
        two: {
            hy: 'oravardzov-2-senyakanoc-bnakaran-',
            ru: 'posutochno-2-komnatnaya-kvartira-',
            en: 'daily-rent-2-room-apartment-',
        },
        tree: {
            hy: 'oravardzov-3-senyakanoc-bnakaran-',
            ru: 'posutochno-3-komnatnaya-kvartira-',
            en: 'daily-rent-3-room-apartment-',
        },
        four: {
            hy: 'oravardzov-4-senyakanoc-bnakaran-',
            ru: 'posutochno-4-komnatnaya-kvartira-',
            en: 'daily-rent-4-room-apartment-',
        },
    },
    dailyHouse: {
        hy: 'oravardzov-arandznatun-',
        ru: 'posutochno-chastnie-doma-',
        en: 'daily-rent-house-',
    },
    dailyHouseNewBuilding: {
        hy: 'oravardzov-norakaruic-arandznatun-',
        ru: 'posutochno-chastnie-doma-novostroiki-',
        en: 'daily-rent-new-house-',
    },
    rentHouseWithRooms: {
        one: {
            hy: 'oravardzov-1-senyakanoc-arandznatun-',
            ru: 'posutochno-1-komnatniy-chastniy-dom-',
            en: 'daily-rent-1-room-house-',
        },
        two: {
            hy: 'oravardzov-2-senyakanoc-arandznatun-',
            ru: 'posutochno-2-komnatniy-chastniy-dom-',
            en: 'daily-rent-2-room-house-',
        },
        tree: {
            hy: 'oravardzov-3-senyakanoc-arandznatun-',
            ru: 'posutochno-3-komnatniy-chastniy-dom-',
            en: 'daily-rent-3-room-house-',
        },
        four: {
            hy: 'oravardzov-4-senyakanoc-arandznatun-',
            ru: 'posutochno-4-komnatniy-chastniy-dom-',
            en: 'daily-rent-4-room-house-',
        },
    },
    dailyRent: {
        hy: 'oravardzov-arandznatun-',
        ru: 'posutochno-chastniy-dom-',
        en: 'daily-rent-house-',
    },
    commercialArea: {
        hy: 'grasenyakayin-taracq-',
        ru: 'kommercheskaya-',
        en: 'commercial-',
    },
    commercialAreaFromDeveloper: {
        hy: 'grasenyakayin-taracq-karucapatoghic-',
        ru: 'kommercheskaya-nedvizhimost-ot-zastroishika-',
        en: 'commercial-new-development-',
    },
    houseNewBuilding: {
        hy: 'norakaruyc-sepakan-tun-',
        ru: 'chastnie-doma-novostroiki-',
        en: 'new-house-',
    },
    newApartment: {
        hy: 'norakaruyc-bnakaran-',
        ru: 'kvartiri-v-novostroikax-',
        en: 'new-apartment-',
    },
    newCommercial: {
        hy: 'norakaruyc-komercion-tarack-',
        ru: 'kommercheskaya-nedvizhimost-v-novostroikax-',
        en: 'new-commercial-',
    },
    rentHouse: {
        hy: 'arandznatun-',
        ru: 'chastniy-dom-',
        en: 'house-',
    },
    newHouse: {
        hy: 'norakaruyc-arandznatun-',
        ru: 'chastnie-doma-novostroiki-',
        en: 'new-house-',
    },
    newRentCommercial: {
        hy: 'norakaruyc-grasenyakayin-taracq-',
        ru: 'kommercheskaya-nedvizhimost-v-novostroikax-',
        en: 'new-commercial-',
    },
};
